import { Controller } from "@hotwired/stimulus";
import aquiferLogoExpandedImg from '../../assets/images/Aquifer-powered-by-Aqueduct.png';
import aquiferLogoCollapsedImg from '../../assets/images/Aquifer_logo_swoosh_white.svg';

export default class extends Controller {
  static targets = ["navigation", "sideNavigation", "sandwichMenuButton"];

  /** Side nav may render twice (primary sidebar + sandwich menu); scope to this controller. */
  forEachSideNavCollapse(fn) {
    this.element.querySelectorAll("[data-side-nav-collapse]").forEach(fn);
  }

  forEachSideNavPanel(fn) {
    this.element.querySelectorAll("[data-side-nav-panel]").forEach(fn);
  }

  focusFirstVisibleCollapseToggle() {
    const toggles = this.element.querySelectorAll("[data-side-nav-collapse]");
    const visible = Array.from(toggles).find((el) => el.offsetParent !== null);
    (visible || toggles[0])?.focus();
  }

  connect() {

    this.toggleSideNavigation();

    setTimeout(() => {
      // All nav links in the side navigation, including nested submenu items
      const navLinks = document.querySelectorAll('.navbar-primary-menu a');
      navLinks.forEach(link => {
        link.addEventListener('keydown', function(e) {
          if (e.key === ' ') {
            e.preventDefault();
            link.click();
          }
        });
      });
    }, 0);
    window.addEventListener("resize", this.toggleSideNavigation.bind(this));
    const navState = sessionStorage.getItem('sideNavState');
    const resourceMenuState = sessionStorage.getItem('resourceMenuState');
    const defaultState = this.data.get('default-state')
    const featureFlagEnabled = this.data.get("featureFlagEnabled") === "true";
    const todoMenuState = sessionStorage.getItem('todoMenuState');
    const quizMenuState = sessionStorage.getItem('quizMenuState');
    const courseMenuState = sessionStorage.getItem('courseMenuState');

    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    if (isSafari) {
    document.documentElement.classList.add('safari');
    }

    if (featureFlagEnabled) {
      if (defaultState ==='collapsed' || navState === 'collapsed') {
        this.collapseNavigation();
        this.forEachSideNavCollapse((el) => el.setAttribute("aria-expanded", "false"));
      }
      else {
        this.expandNavigation();
        this.forEachSideNavCollapse((el) => el.setAttribute("aria-expanded", "true"));
      }
    }
    if (defaultState !== 'collapsed') {
      if (resourceMenuState === null || resourceMenuState === 'collapsed') {
        this.collapseResourceMenu();
      }
      else {
        this.expandResourceMenu()
      }
      if (todoMenuState === null || todoMenuState === 'collapsed') {
        this.collapseTodoMenu();
      }
      else {
        this.expandTodoMenu()
      }
      if (quizMenuState === null || quizMenuState === 'collapsed') {
        this.collapseQuizMenu();
      }
      else{
        this.expandQuizMenu();
      }
      if (courseMenuState === null || courseMenuState === 'collapsed') {
        this.collapseCourseMenu();
      }
      else {
        this.expandCourseMenu();
      }

    }
    let cookies = document.cookie.split('; ');
    let cookie = cookies.find(row => row.startsWith('programMenuState='));
    if (cookie === undefined || cookie.split('=')[1] === 'collapsed') {
      this.collapseProgramsMenu();
    }
    else {
      this.expandProgramsMenu()
    }

    // Ensure aria-expanded is correct on initial load if featureFlagEnabled is not set
    if (!featureFlagEnabled) {
      this.forEachSideNavCollapse((collapseImg) => {
        const controlsId = collapseImg.getAttribute("aria-controls");
        const sideNavDiv = controlsId && document.getElementById(controlsId);
        if (sideNavDiv) {
          collapseImg.setAttribute(
            "aria-expanded",
            sideNavDiv.classList.contains("collapsed") ? "false" : "true"
          );
        }
      });
    }
  }

  toggleNavigation() {
    const sideNavDiv = this.element.querySelector("[data-side-nav-panel]");
    if (!sideNavDiv) return;
    if (sideNavDiv.classList.contains("collapsed")) {
      this.expandNavigation();
      this.forEachSideNavCollapse((el) => el.setAttribute("aria-expanded", "true"));
      this.focusFirstVisibleCollapseToggle();
      this.element.querySelectorAll(".side-nav-status-announcement").forEach((status) => {
        status.textContent = "Side navigation expanded";
      });
    } else {
      this.collapseNavigation();
      this.forEachSideNavCollapse((el) => el.setAttribute("aria-expanded", "false"));
      this.focusFirstVisibleCollapseToggle();
      this.element.querySelectorAll(".side-nav-status-announcement").forEach((status) => {
        status.textContent = "Side navigation collapsed";
      });
    }
  }

  expandNavigation() {
    const sideNavMainContent = document.getElementById("side-nav-main-content");

    this.forEachSideNavPanel((sideNavDiv) => {
      sideNavDiv.classList.remove("collapsed");
    });
    document.getElementById("panel-sticky")?.classList?.remove("smaller-sticky-info");

    if(sideNavMainContent){
      sideNavMainContent.classList.remove("collapsed");
    }
    this.element.querySelectorAll('[id^="side-navigation-profile-icon-"]').forEach((el) => {
      el.classList.remove("collapsed");
    });
    this.element.querySelectorAll('[id^="log-out-div-main-"]').forEach((el) => {
      el.classList.remove("collapsed");
    });
    document.querySelectorAll(".resources-menu-img").forEach((el) => el.classList.remove("collapsed"));
    document.querySelectorAll(".programs-menu-img").forEach((el) => el.classList.remove("collapsed"));
    document.querySelectorAll(".todo-menu-img").forEach((el) => el.classList.remove("collapsed"));
    document.querySelectorAll(".quiz-menu-img").forEach((el) => el.classList.remove("collapsed"));
    document.querySelectorAll(".course-menu-img").forEach((el) => el.classList.remove("collapsed"));
    document.querySelectorAll(".st-accordion__list").forEach(element => {
      element.classList.remove("collapsed");
    });
    document.querySelectorAll(".side-navigation-icon-container").forEach(element => {
      element.removeAttribute("title");
    });
    const setExpandedAquiferLogo = (aquiferLogoImage) => {
      aquiferLogoImage.src = aquiferLogoExpandedImg;
      aquiferLogoImage.style.marginLeft = "13px";
    };
    this.element.querySelectorAll('[id^="aquifer-logo-img-alt-"]').forEach(setExpandedAquiferLogo);
    this.element.querySelectorAll('[id^="aquifer-logo-img-default-"]').forEach(setExpandedAquiferLogo);
    this.forEachSideNavCollapse((collapseImg) => {
      collapseImg.classList.remove('right');
      collapseImg.classList.add('left');
    });
    sessionStorage.setItem('sideNavState', 'expanded');
  }

  collapseNavigation() {
    const sideNavMainContent = document.getElementById("side-nav-main-content");

    this.forEachSideNavPanel((sideNavDiv) => {
      sideNavDiv.classList.add("collapsed");
    });
    if (sideNavMainContent) {
      sideNavMainContent.classList.add("collapsed");
    }
    this.element.querySelectorAll('[id^="side-navigation-profile-icon-"]').forEach((el) => {
      el.classList.add("collapsed");
    });
    this.element.querySelectorAll('[id^="log-out-div-main-"]').forEach((el) => {
      el.classList.add("collapsed");
    });
    document.getElementById("panel-sticky")?.classList?.add("smaller-sticky-info");
    document.querySelectorAll(".resources-menu-img").forEach((el) => el.classList.add("collapsed"));
    document.querySelectorAll(".programs-menu-img").forEach((el) => el.classList.add("collapsed"));
    document.querySelectorAll(".st-accordion__list").forEach(element => {
      element.classList.add("collapsed");
    });
    document.querySelectorAll(".side-navigation-icon-container").forEach(element => {
      const divTitle=element.querySelector("span").innerHTML
      element.setAttribute("title", divTitle);
    });
    document.querySelectorAll(".todo-menu-img").forEach((el) => el.classList.add("collapsed"));
    document.querySelectorAll(".quiz-menu-img").forEach((el) => el.classList.add("collapsed"));
    document.querySelectorAll(".course-menu-img").forEach((el) => el.classList.add("collapsed"));

    const setCollapsedAquiferLogo = (aquiferLogoImage) => {
      aquiferLogoImage.src = aquiferLogoCollapsedImg;
      aquiferLogoImage.style.marginLeft = "0px";
    };
    this.element.querySelectorAll('[id^="aquifer-logo-img-alt-"]').forEach(setCollapsedAquiferLogo);
    this.element.querySelectorAll('[id^="aquifer-logo-img-default-"]').forEach(setCollapsedAquiferLogo);
    this.forEachSideNavCollapse((collapseImg) => {
      collapseImg.classList.remove('left');
      collapseImg.classList.add('right');
    });
    this.collapseResourceMenu()
    this.collapseProgramsMenu()
    this.collapseTodoMenu()
    this.collapseQuizMenu()
    this.collapseCourseMenu()
    sessionStorage.setItem('sideNavState', 'collapsed');
  }

  toggleResourcesMenu() {
    if (sessionStorage.getItem('sideNavState')!== 'collapsed') {
      const resourcesMenuElements = document.getElementsByClassName("resources_content")
      const resourceArray = Array.from(resourcesMenuElements);
      const hasCollapsed = resourceArray.some(element => element.classList.contains("collapsed"));
      if (hasCollapsed) {
        this.expandResourceMenu();
      } else {
        this.collapseResourceMenu();
      }
    }else{
      this.expandNavigation()
      this.expandResourceMenu()
    }
  }

  expandResourceMenu() {
    const resourcesMenuElements = document.getElementsByClassName("resources_content")
    const resourceArray = Array.from(resourcesMenuElements);
    const resourcesMenuImages = document.getElementsByClassName("resources-menu-img")
    const resourcesMenuImagesArray = Array.from(resourcesMenuImages);
    this.element.querySelectorAll('[aria-controls^="resources-div-submenu"]').forEach((trigger) => {
      trigger.setAttribute("aria-expanded", "true");
    });
    if (resourceArray && resourceArray.length > 0) {
      resourceArray.forEach(element => {
        element.classList.remove("collapsed");
        element.setAttribute("aria-hidden", "false");
      });
    }
    if (resourcesMenuImagesArray && resourcesMenuImagesArray.length > 0) {
      resourcesMenuImagesArray.forEach(element => {
        element.classList.add("expanded");
      });
    }
    sessionStorage.setItem('resourceMenuState', 'expanded');
  }

  collapseResourceMenu() {
    const resourcesMenuElements = document.getElementsByClassName("resources_content")
    const resourceArray = Array.from(resourcesMenuElements);
    const resourcesMenuImages = document.getElementsByClassName("resources-menu-img")
    const resourcesMenuImagesArray = Array.from(resourcesMenuImages);
    this.element.querySelectorAll('[aria-controls^="resources-div-submenu"]').forEach((trigger) => {
      trigger.setAttribute("aria-expanded", "false");
    });
    if (resourceArray && resourceArray.length > 0) {
      resourceArray.forEach(element => {
        element.classList.add("collapsed")
        element.setAttribute("aria-hidden", "true");
      });
    }
    if (resourcesMenuImagesArray && resourcesMenuImagesArray.length > 0) {
      resourcesMenuImagesArray.forEach(element => {
        element.classList.remove("expanded");
      });
    }
    sessionStorage.setItem('resourceMenuState', 'collapsed');
  }

  toggleProgramsMenu() {
    if (sessionStorage.getItem('sideNavState')!== 'collapsed') {
      const programMenuElements = document.getElementsByClassName("program_content")
      const programArray = Array.from(programMenuElements);
      const hasCollapsed = programArray.some(element => element.classList.contains("collapsed"));
      if (hasCollapsed) {
        this.expandProgramsMenu();
      } else {
        this.collapseProgramsMenu();
      }
    }else{
      this.expandNavigation()
      this.expandProgramsMenu()
    }
  }

  expandProgramsMenu() {
    const programMenuElements = document.getElementsByClassName("program_content")
    const programArray = Array.from(programMenuElements);
    const programMenuImages = document.getElementsByClassName("programs-menu-img")
    const programMenuImagesArray = Array.from(programMenuImages);
    this.element.querySelectorAll('[aria-controls^="programs-div"]').forEach((trigger) => {
      trigger.setAttribute("aria-expanded", "true");
    });
    if (programArray && programArray.length > 0) {
      programArray.forEach(element => {
        element.classList.remove("collapsed");
        element.setAttribute("aria-hidden", "false");
      });
    }
    if (programMenuImagesArray && programMenuImagesArray.length > 0) {
      programMenuImagesArray.forEach(element => {
        element.classList.add("expanded");
      });
    }
    document.cookie = "programMenuState=expanded; path=/";
  }

  collapseProgramsMenu() {
    const programMenuElements = document.getElementsByClassName("program_content")
    const programArray = Array.from(programMenuElements);
    const programMenuImages = document.getElementsByClassName("programs-menu-img")
    const programMenuImagesArray = Array.from(programMenuImages);
    this.element.querySelectorAll('[aria-controls^="programs-div"]').forEach((trigger) => {
      trigger.setAttribute("aria-expanded", "false");
    });
    if (programArray && programArray.length > 0) {
      programArray.forEach(element => {
        element.classList.add("collapsed");
        element.setAttribute("aria-hidden", "true");
      });
    }
    if (programMenuImagesArray && programMenuImagesArray.length > 0) {
      programMenuImagesArray.forEach(element => {
        element.classList.remove("expanded");
      });
    }
    document.cookie = "programMenuState=collapsed; path=/";
  }

  toggleSideNavigation() {
    const screenWidth = document.documentElement.clientWidth || document.body.clientWidth || window.innerWidth;
    const featureFlagEnabled = this.data.get("featureFlagEnabled") === "true";
    const hideSidebar = this.data.get("hideSidebar") === "true";
    const sideNavMainContent = document.getElementById("side-nav-main-content");

    if (featureFlagEnabled && !hideSidebar && screenWidth >= 834) {
      this.navigationTarget.style.display = "none";
      this.navigationTarget.setAttribute("aria-hidden", "true");
      this.sideNavigationTarget.style.display = "block";
      this.sideNavigationTarget.removeAttribute("aria-hidden");
      if (sideNavMainContent) {
        sideNavMainContent.classList.remove("top-navigation");
      }
    } else {
      this.navigationTarget.style.display = "block";
      this.navigationTarget.removeAttribute("aria-hidden");
      this.sideNavigationTarget.style.display = "none";
      this.sideNavigationTarget.setAttribute("aria-hidden", "true");
      if (sideNavMainContent) {
        sideNavMainContent.classList.add("top-navigation");
      }
    }
  }

  toggleSadndwichBarNavigation(){
    const sideNavDiv = document.getElementById("sandwitch-bar-nav-div");
    sideNavDiv.classList.toggle("show");
    const isOpen = sideNavDiv.classList.contains("show");
    if (isOpen) {
      sideNavDiv.removeAttribute("aria-hidden");
    } else {
      sideNavDiv.setAttribute("aria-hidden", "true");
    }
    if (this.hasSandwichMenuButtonTarget) {
      const btn = this.sandwichMenuButtonTarget;
      btn.setAttribute("aria-expanded", isOpen ? "true" : "false");
      btn.setAttribute("aria-label", isOpen ? "Close navigation menu" : "Open navigation menu");
    }
  }

  toggleQuizMenu() {
    if (sessionStorage.getItem('sideNavState')!== 'collapsed') {
      const elements = document.getElementsByClassName("quiz_content")
      const array = Array.from(elements);
      const hasCollapsed = array.some(e => e.classList.contains("collapsed"));
      if (hasCollapsed) {
        this.expandQuizMenu();
      } else {
        this.collapseQuizMenu();
      }
    }else{
      this.expandNavigation()
      this.expandQuizMenu()
    }
  }

  expandQuizMenu() {
    const elements = document.getElementsByClassName("quiz_content")
    const array = Array.from(elements);
    const images = document.getElementsByClassName("quiz-menu-img")
    const imagesArray = Array.from(images);
    this.element.querySelectorAll('[aria-controls^="quiz-div"]').forEach((trigger) => {
      trigger.setAttribute("aria-expanded", "true");
    });
    if (array && array.length > 0) {
      array.forEach(e => {
        e.classList.remove("collapsed");
        e.setAttribute("aria-hidden", "false");
      });
    }
    if (imagesArray && imagesArray.length > 0) {
      imagesArray.forEach(e => {
        e.classList.add("expanded");
      });
    }
    sessionStorage.setItem('quizMenuState', 'expanded');
  }

  collapseQuizMenu() {
    const elements = document.getElementsByClassName("quiz_content")
    const array = Array.from(elements);
    const images = document.getElementsByClassName("quiz-menu-img")
    const imagesArray = Array.from(images);
    this.element.querySelectorAll('[aria-controls^="quiz-div"]').forEach((trigger) => {
      trigger.setAttribute("aria-expanded", "false");
    });
    if (array && array.length > 0) {
      array.forEach(e => {
        e.classList.add("collapsed");
        e.setAttribute("aria-hidden", "true");
      });
    }
    if (imagesArray && imagesArray.length > 0) {
      imagesArray.forEach(e => {
        e.classList.remove("expanded");
      });
    }
    sessionStorage.setItem('quizMenuState', 'collapsed');
  }

  toggleTodoMenu(){
    if (sessionStorage.getItem('sideNavState')!== 'collapsed') {
      const todoMenuElements = document.getElementsByClassName("todo_content")
      const todoArray = Array.from(todoMenuElements);
      const hasCollapsed = todoArray.some(element => element.classList.contains("collapsed"));
      if (hasCollapsed) {
        this.expandTodoMenu();
      } else {
        this.collapseTodoMenu();
      }
    }else{
      this.expandNavigation()
      this.expandTodoMenu()
    }
  }

  expandTodoMenu() {
    const todoMenuElements = document.getElementsByClassName("todo_content")
    const todoArray = Array.from(todoMenuElements);
    const todoMenuImages = document.getElementsByClassName("todo-menu-img")
    const todoMenuImagesArray = Array.from(todoMenuImages);
    this.element.querySelectorAll('[aria-controls^="todo-div"]').forEach((trigger) => {
      trigger.setAttribute("aria-expanded", "true");
    });
    if (todoArray && todoArray.length > 0) {
      todoArray.forEach(element => {
        element.classList.remove("collapsed");
        element.setAttribute("aria-hidden", "false");
      });
    }
    if (todoMenuImagesArray && todoMenuImagesArray.length > 0) {
      todoMenuImagesArray.forEach(element => {
        element.classList.add("expanded");
      });
    }
    sessionStorage.setItem('todoMenuState', 'expanded');
  }

  collapseTodoMenu() {
    const todoMenuElements = document.getElementsByClassName("todo_content")
    const todoArray = Array.from(todoMenuElements);
    const todoMenuImages = document.getElementsByClassName("todo-menu-img")
    const todoMenuImagesArray = Array.from(todoMenuImages);
    this.element.querySelectorAll('[aria-controls^="todo-div"]').forEach((trigger) => {
      trigger.setAttribute("aria-expanded", "false");
    });
    if (todoArray && todoArray.length > 0) {
      todoArray.forEach(element => {
        element.classList.add("collapsed")
        element.setAttribute("aria-hidden", "true");
      });
    }
    if (todoMenuImagesArray && todoMenuImagesArray.length > 0) {
      todoMenuImagesArray.forEach(element => {
        element.classList.remove("expanded");
      });
    }
    sessionStorage.setItem('todoMenuState', 'collapsed');
  }

  toggleCourseMenu() {
    if (sessionStorage.getItem('sideNavState') !== 'collapsed') {
      const courseMenuElements = document.getElementsByClassName("course_content")
      const courseArray = Array.from(courseMenuElements);
      const hasCollapsed = courseArray.some(e => e.classList.contains("collapsed"));
      
      if (hasCollapsed) {
        this.expandCourseMenu();
      } else {
        this.collapseCourseMenu();
      }
    } else {
      this.expandNavigation()
      this.expandCourseMenu()
    }
  }

  expandCourseMenu() {    
    const courseMenuElements = document.getElementsByClassName("course_content")
    const courseArray = Array.from(courseMenuElements);
    const images = document.getElementsByClassName("course-menu-img")
    const imagesArray = Array.from(images);
    this.element.querySelectorAll('[aria-controls^="courses-div-submenu"]').forEach((trigger) => {
      trigger.setAttribute("aria-expanded", "true");
    });
    if (courseArray && courseArray.length > 0) {
      courseArray.forEach(e => {
        e.classList.remove("collapsed");
        e.setAttribute("aria-hidden", "false");
      });
    }
    if (imagesArray && imagesArray.length > 0) {
      imagesArray.forEach(e => {
        e.classList.add("expanded");
      });
    }
    sessionStorage.setItem('courseMenuState', 'expanded');
  }

  collapseCourseMenu() {    
    const courseMenuElements = document.getElementsByClassName("course_content")
    const courseArray = Array.from(courseMenuElements);
    const images = document.getElementsByClassName("course-menu-img")
    const imagesArray = Array.from(images);
    this.element.querySelectorAll('[aria-controls^="courses-div-submenu"]').forEach((trigger) => {
      trigger.setAttribute("aria-expanded", "false");
    });
    if (courseArray && courseArray.length > 0) {
      courseArray.forEach(e => {
        e.classList.add("collapsed");
        e.setAttribute("aria-hidden", "true");
      });
    }
    if (imagesArray && imagesArray.length > 0) {
      imagesArray.forEach(e => {
        e.classList.remove("expanded");
      });
    }
    sessionStorage.setItem('courseMenuState', 'collapsed');
  }

  handleKeypressToggleNavigation(event){
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.toggleNavigation();
    }
  }

  handleKeypressToggleTodoMenu(event){
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.toggleTodoMenu();
    }
  }

  handleKeypressToggleQuizMenu(event){
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.toggleQuizMenu();
    }
  }

  handleKeypressToggleResourcesMenu(event){
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.toggleResourcesMenu();
    }
  }

  handleKeypressToggleProgramsMenu(event){
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.toggleProgramsMenu();
    }
  }

  handleKeypressToggleCourseMenu(event){
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.toggleCourseMenu();
    }
  }
}
